import anime from 'animejs/lib/anime.es.js';
import StateMachine from 'javascript-state-machine/lib/state-machine.js';
import Utils from './utils.js';

/* HTML code

<div data-ma-accordion class="ma-accordion" id="accordion-id-1">
  <div data-container-accordion class="ma-accordion__container">
    <h5 data-toggle-accordion="accordion-id-1">Title</h5>
    <div data-content-accordion class="ma-accordion__content">
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec semper pretium sagittis. Nullam vehicula commodo, lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec semper pretium sagittis.
      </p>
    </div>
  </div>
</div>

*/
class AccordionHelper {
  constructor(el, clickEvent, toggleDataAttr, selectorEl, containerSelectorEl, callbackStartAnimFunc, callbackEndAnimFunc, closeOtherTabsFunc, scrollToSection, onlyOpens, extraHeightfunc, forceRedraw) {
    this.el = el;
    this.clickEvent = clickEvent ? clickEvent : false;
    this.toggleDataAttr = toggleDataAttr ? toggleDataAttr : 'data-toggle-accordion';
    this.selectorEl = selectorEl ? selectorEl : '[data-ma-accordion]';
    this.containerSelectorEl = containerSelectorEl ? containerSelectorEl : '[data-container-accordion]';
    this.callbackStartAnimFunc = callbackStartAnimFunc;
    this.callbackEndAnimFunc = callbackEndAnimFunc;
    this.closeOtherTabsFunc = closeOtherTabsFunc;
    this.scrollToSection = scrollToSection;
    this.onlyOpens = onlyOpens;
    this.extraHeightfunc = extraHeightfunc || function() { return 0; };
    this.forceRedraw = forceRedraw || false;

    this.accordionId = this.el.getAttribute('id');
    this.toggleIsInsideAcc = this.el.querySelector('['+ this.toggleDataAttr + '="'+ this.accordionId +'"]') ? true : false;
    this.toggleEl = this.toggleIsInsideAcc ? this.el.querySelector('['+ this.toggleDataAttr + '="'+ this.accordionId +'"]') : null;
    this.toggleOutsideEls = !this.toggleIsInsideAcc ? document.querySelectorAll('['+ this.toggleDataAttr + '="'+ this.accordionId +'"]') : null;
    this.containerEl = this.el.querySelector(this.containerSelectorEl);
    this.contentEl = this.containerEl.querySelector('[data-content-accordion]');
    this.contentEl.style.display = 'block';

    this.isOpen = this.el.getAttribute('data-ma-accordion-is-open') ? true : false; //LIDA project

    this.initHeight = this.toggleIsInsideAcc ? this.toggleEl?.getBoundingClientRect().height : 0;//if the toggle is outside the container, the container height is zero

    if(this.toggleIsInsideAcc)
      this.heightContainer = this.extraHeightfunc() && Utils.isMobileView ? this.toggleEl?.getBoundingClientRect().height + this.contentEl.getBoundingClientRect().height + this.extraHeightfunc() : this.toggleEl?.getBoundingClientRect().height + this.contentEl.getBoundingClientRect().height;
    else
      this.heightContainer = this.extraHeightfunc() && Utils.isMobileView ? this.contentEl.getBoundingClientRect().height + this.extraHeightfunc() : this.contentEl.getBoundingClientRect().height;

    this.animTiming = 400 * this.heightContainer / 300; // 400ms to 300px of height/

    if(this.animTiming > 1500) {//if anim time is more than 1500ms stays 1500ms
      this.animTiming = 1500;
    } else if(this.animTiming < 400) { //if anim time is less than 500ms stays 500ms
      this.animTiming = 400;
    }

    this.throttlePause = undefined;

    this.states = undefined;
    this.animations = {
      openSelectedTab : {
        params: undefined,
        anim: undefined
      },
      closeSelectedTab : {
        params: undefined,
        anim: undefined
      }
    };
  }


  /*
   * INIT
   */
  init() {
    this._initStates();
    this._initAnimations();

    //init height
    this.el.style.maxHeight = this.initHeight +'px';

    this.el.classList.add('ma-accordion--ready');

    if(this.toggleIsInsideAcc) {
      this.toggleEl?.addEventListener('click', event => {
        if(this.onlyOpens && this.states.state == 'closed')
          event.preventDefault();

        if(this.clickEvent) {
          if(this.onlyOpens && this.states.state == 'closed' || !this.onlyOpens)
            this.clickHandler();
        }

      });
    } else {
      this.toggleOutsideEls?.forEach(toggleEl => {
        toggleEl.addEventListener('click', event => {
          if(this.onlyOpens && this.states.state == 'closed')
            event.preventDefault();

          if(this.clickEvent) {
            if(this.onlyOpens && this.states.state == 'closed' || !this.onlyOpens)
              this.clickHandler();
          }

        });
      });
    }

    if(this.states.state == 'open')
      this.open();

    let rafForResizeId = undefined;
    window.addEventListener('resize', event => {
      rafForResizeId = Utils.debouncedRequestAnimationFrame(rafForResizeId, () => this.updateHeight());
    });
  }


  /*
   * Update Height
   */
  updateHeight(doNotUpdateOnDom) {
    this.el.classList.remove('ma-accordion--ready');
    this.el.style.minHeight = 'initial';

    this.initHeight = this.toggleIsInsideAcc ? this.toggleEl?.getBoundingClientRect().height : 0;

    let contentHeight = this.contentEl.getBoundingClientRect().height;

    if(doNotUpdateOnDom) {
      contentHeight = Array.from(this.contentEl.children).reduce((previousValue, currentEl) => {
        return previousValue += currentEl.getBoundingClientRect().height;
      }, 0);
    }

    if(this.toggleIsInsideAcc)
      this.heightContainer = this.extraHeightfunc() && Utils.isMobileView ? this.toggleEl?.getBoundingClientRect().height + contentHeight + this.extraHeightfunc() : this.toggleEl?.getBoundingClientRect().height + contentHeight;
    else
      this.heightContainer = this.extraHeightfunc() && Utils.isMobileView ? contentHeight + this.extraHeightfunc() : contentHeight;

    this.animTiming = 400 * this.heightContainer / 300; // 400ms to 300px of height/

    if(this.animTiming > 1500) {//if anim time is more than 1500ms stays 1500ms
      this.animTiming = 1500;
    } else if(this.animTiming < 400) { //if anim time is less than 500ms stays 500ms
      this.animTiming = 400;
    }

    this._resetAnimations();
    this.el.classList.add('ma-accordion--ready');

    if(!doNotUpdateOnDom) {
      if(this.states.state == 'closed') {
        this.el.style.maxHeight = this.initHeight +'px';
      } else {
        this.el.style.minHeight = this.heightContainer +'px';
      }
    }
  }


  /*
   * Update max height for future content change and consequent height update
   */
  updateMaxHeightForContentChange() {
    if(this.states.state == 'open')
      this.el.style.maxHeight = this.heightContainer +'px';
  }



  /*
   * Init states
   */
  _initStates() {
    this.states = new StateMachine({
      init: this.isOpen ? 'open' : 'closed',
      transitions: [
        { name: 'open',  from: 'closed', to: 'open'   },
        { name: 'close', from: 'open',   to: 'closed' }
      ]
    });
  }


  /*
   * Init animations
   */
  _initAnimations() {
    this.animations.openSelectedTab.params = {
      targets: this.el,
      maxHeight: this.heightContainer+'px',
      minHeight: this.heightContainer+'px',
      duration: this.animTiming,
      easing: 'easeInOutQuad',
      begin: anim => {
        if(this.forceRedraw)
          this.containerEl.style.position = 'relative'; //force to redraw on chrome (bug chrome)

        if(this.states.state == 'closed') {

          //* Open Tab
          this.el.classList.add('tab--active');
          this.el.classList.add('tab--animate');

          if(this.toggleIsInsideAcc)
            this.toggleEl?.classList.add('toggle--active');
          else
            this.toggleOutsideEls?.forEach(toggleEl => toggleEl.classList.add('toggle--active'));

          this.states.open();

          //* Close the other tabs
          if(this.closeOtherTabsFunc)
            this.closeOtherTabsFunc();
        }

        if (this.callbackStartAnimFunc) {
          this.callbackStartAnimFunc(this);
        }
      },
      complete: anim => {
        this.el.classList.remove('tab--animate');

        if(this.scrollToSection && Utils.isMobileView) {
          if(this.states.state == 'open') {
            var y = $(window).scrollTop();
            var scrollToPost = y + this.el.getBoundingClientRect().top - document.querySelector('header').getBoundingClientRect().top - document.querySelector('header').getBoundingClientRect().height - document.querySelector('[data-toggle-accordion]').getBoundingClientRect().height ;

            if(!isInHeightViewport( this.el, 60, window.innerHeight/4)) {
              $('html, body').animate({scrollTop: scrollToPost }, this.animTiming);
            }
          }
        }

        this.el.style.maxHeight = 'initial';

        if (this.callbackEndAnimFunc) {
          this.callbackEndAnimFunc(this);
        }
      }
    };

    this.animations.closeSelectedTab.params = {
      targets: this.el,
      maxHeight: this.initHeight+'px',
      minHeight: this.initHeight+'px',
      duration: this.animTiming,
      easing: 'easeInOutQuad',
      begin: anim => {
        if(this.states.state == 'open') {
          this.el.style.maxHeight = this.heightContainer;

          //* Close tab
          this.el.classList.remove('tab--active');
          this.el.classList.add('tab--animate');

          if(this.toggleIsInsideAcc)
            this.toggleEl?.classList.remove('toggle--active');
          else
            this.toggleOutsideEls?.forEach(toggleEl => toggleEl.classList.remove('toggle--active'));


          this.states.close();
        }

        if (this.callbackStartAnimFunc) {
          this.callbackStartAnimFunc(this);
        }
      },
      complete: anim => {
        this.el.classList.remove('tab--animate');

        if(this.forceRedraw)
          this.containerEl.style.position = 'absolute'; //force to redraw on chrome (bug chrome)

        if (this.callbackEndAnimFunc) {
          this.callbackEndAnimFunc(this);
        }
      }
    };
  }


  /*
   * Reset animations
   */
  _resetAnimations() {
    this.animations = {
      openSelectedTab : {
        params: undefined,
        anim: undefined
      },
      closeSelectedTab : {
        params: undefined,
        anim: undefined
      }
    };

    this._initAnimations();
  }


  /*
   * Click Handler
   */
  clickHandler() {
    //update state based on .tab--active
    if(this.states.state == 'open') {
      this.close();
    }
    else if(this.states.state == 'closed') {
      this.open();
    }
  }

  /*
   * Open
   */
  open() {
    this._initAnimation('openSelectedTab');

    if(this.states.state == 'closed') {
      this.animations.openSelectedTab.anime.direction = 'normal';
      this.animations.openSelectedTab.anime.play();
    }

    const eventOpen = new Event('openAccordion');
    document.body.dispatchEvent(eventOpen);
  }

  /*
   * Force Open - content changed neeed new animation
   */
  forceOpen() {
    this._initAnimation('openSelectedTab');

    this.animations.openSelectedTab.anime.direction = 'normal';
    this.animations.openSelectedTab.anime.play();

    const eventOpen = new Event('openAccordion');
    document.body.dispatchEvent(eventOpen);
  }

  /*
   * Close
   */
  close() {
    this._initAnimation('closeSelectedTab');

    if(this.states.state == 'open') {
      this.animations.closeSelectedTab.anime.direction = 'normal';
      this.animations.closeSelectedTab.anime.play();
    }

    const eventClose = new Event('closeAccordion');
    document.body.dispatchEvent(eventClose);
  }


  /*
   * Init animation
   */
  _initAnimation(name) {
    if(!this.animations[name].anime)
      this.animations[name].anime = anime(this.animations[name].params);
  }
}

export default AccordionHelper;
